<template lang="pug">
div
  v-container
    v-row
      v-col(:lg="12", :md="12", :sm="12", :cols="12")
        p.pb-0.pl-8.text--secondary The applicant covenants to save, defend, hold harmless and indemnify the County, and all of its officers, departments, agencies, agent and employees (Collectively the &quot;County&quot;) from and against any all claims, losses, damages, injuries, fines, penalties, costs (including court costs and attorney&quot;s fees), charges, liability, or exposure, however caused, resulting from, arising out of, or in any way connected with the applicant&quot;s event as herein described.
    v-row
      v-col(:lg="12", :md="12", :sm="12", :cols="12")
        p.pb-0.body-1 Signature of Event Sponsor
        v-checkbox(
          v-model="attest",
          label="I attest the information in this application is true and accurate."
          :disabled="disabled"
        )
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
    }),
    ...mapFields([
      "data.attest",
      "data.disabled",
    ]),
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
};
</script>